// src/hooks/api/useChatThreads.js
import { useQuery } from "@tanstack/react-query";
import { getChatThreadsApi } from "api/chatThreadsApi";

export const useChatThreads = (params = {}) => {
  return useQuery({
    queryKey: ["chat-threads", params],
    queryFn: () => getChatThreadsApi(params),
    keepPreviousData: true,
  });
};
